import React from "react";
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";

export const facilityLoader = async ({ params }) => {
  const token = getToken();
  const res = await instance.get("/doctor/facility", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const FacilityPage = () => {
  const facility = useLoaderData();
  const location = useLocation();
  const tabs = [
    {
      id: 1,
      title: "Information",
      href: `/dashboard/facility`,
    },
    {
      id: 2,
      title: "Members",
      href: `/dashboard/facility/members`,
    },
    {
      id: 3,
      title: "Clinic Referrals",
      href: `/dashboard/facility/clinic-referrals`,
    }
  ];

  return (
    <div className={`max-h-[100vh] bg-white overflow-y-scroll scrollbar-hide`}>
      <div className="sticky left-0 right-0 top-0 z-10">
        <div className="bg-[#fafafa] px-10 py-5">
          <p className="text-[18px] font-medium select-none">
            {facility.name} Facility
          </p>
        </div>

        <div className="bg-[#fafafa] px-7 flex border-t border-b overflow-x-scroll scrollbar-hide whitespace-nowrap">
          {tabs.map((item) => (
            <Link
              to={item.href}
              key={item.id}
              className={`${
                location.pathname === item.href
                  ? "bg-[#00b0ad0d] border-[#00B0AD] text-black font-medium"
                  : "font-medium text-gray-800 border-b-transparent"
              } border-t-[3px] border-t-transparent border-b-[3px]  cursor-pointer p-3 text-[13px] select-none`}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
};
